import { useState } from "react";
import { fileUrl, thumbUrl } from "@/lib/api";

const THUMB_W = { xs: 160, sm: 160, md: 160, lg: 320, xl: 480 };

function ArtworkImage({ artworkId, title, size }) {
  const [src, setSrc] = useState(() => thumbUrl(artworkId, THUMB_W[size] || 320));
  return (
    <img src={src} alt={title} loading="lazy" decoding="async" className="w-full h-full object-cover"
      onError={() => { const full = fileUrl(artworkId); if (src !== full) setSrc(full); }} />
  );
}

export function ArtworkPlaceholder({ title = "", artworkId = null, size = "md", className = "" }) {
  const sizes = { xs: "w-8 h-8 text-[8px]", sm: "w-10 h-10 text-[9px]", md: "w-14 h-14 text-[10px]", lg: "w-24 h-24 text-xs", xl: "w-40 h-40 text-sm" };
  if (artworkId) {
    return (
      <div className={`${sizes[size]} rounded-lg overflow-hidden bg-[#1F1F22] shrink-0 ${className}`}>
        <ArtworkImage key={artworkId} artworkId={artworkId} title={title} size={size} />
      </div>
    );
  }
  // hash title -> gradient tone
  const hash = Array.from(title || "").reduce((a, c) => a + c.charCodeAt(0), 0);
  const hue = 260 + (hash % 40) - 20;
  return (
    <div
      className={`${sizes[size]} rounded-lg shrink-0 flex flex-col items-center justify-center relative overflow-hidden border border-white/5 ${className}`}
      style={{
        background: `radial-gradient(circle at 30% 20%, hsl(${hue}, 55%, 20%), #101013 70%)`,
      }}
      data-testid="artwork-placeholder"
    >
      <div className="absolute inset-0 opacity-30" style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.4'/%3E%3C/svg%3E\")" }} />
      <div className="relative font-bold tracking-[0.25em] text-white/60">LXN</div>
      {size !== "xs" && size !== "sm" && title && (
        <div className="relative text-white/40 text-center px-2 leading-tight mt-1 truncate w-full">{title.slice(0, 14)}</div>
      )}
    </div>
  );
}
